<template>
  <vs-popup class="two-fa-popup"
            id="popup"
            :title="'2FA CONFIRM'"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <div class="flex flex-wrap items-center justify-center mt-2 ">
        <img width="200" v-bind:src="form.google_2fa_url"/>
      </div>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-carrier-popup" @submit.prevent="handleSubmit(onClickCreateCarrier)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required|min:6|max:6" v-slot="{ errors }">
                <small class="label">Code</small>
                <vs-input v-model="verification_code" name="name" class="w-full" label="" :danger="!!errors[0]"
                          :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Confirm</vs-button>
            <vs-button @click="onClickClose()" class="mt-2 ml-4" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
const StaffRepository = RepositoryFactory.get('staff');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      name: ''
    },
    isCreateMode: true,
    verification_code: '',
    staff_id: '',
  }
}

export default {
  name: 'TwoFAPopUp',
  data() {
    return initialState()
  },
  methods: {
    onClickClose() {
      this.open = false
      location.reload()
    },
    async openPopup(staff_id) {
      try {
        Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.staff_id = staff_id
        this.open = true;
        await this.fetchCarrierDetails()
      } catch (error) {

      }
    },
    async fetchCarrierDetails() {
      await this.$vs.loading({
        container: '#create-carrier-popup',
        scale: 0.45
      })
      try {
        const {data} = (await StaffRepository.get2FAQRCode(this.staff_id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-carrier-popup > .con-vs-loading')
    },
    async onClickCreateCarrier() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-carrier-popup',
        scale: 0.45
      })
      try {
        await StaffRepository.enable2FA({ secret: this.verification_code }, this.staff_id);
        this.showSuccessMessage('2FA enabled successfully');
        this.$emit('refreshData')
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-carrier-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-carrier-popup > .con-vs-loading')
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.two-fa-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 20% !important;
}

</style>
